import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {entitlementGrantChangeLogStateSelector} from './entitlement-grant-change-log-state.slice';

import type {EntitlementGrantLogsCriteria} from '../typedef';
import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {LogHits} from 'src/openapi/admin/models/LogHits';


export const entitlementGrantChangeLogSlice = getCachedTableDataSlice<
    LogHits[],
    undefined,
    undefined,
    EntitlementGrantLogsCriteria
>('entitlementGrantChangeLog');

export const entitlementGrantChangeLogActions = entitlementGrantChangeLogSlice.actions;
const entitlementGrantChangeLogCacheSelector: CachedTableCacheSelector<LogHits[]>
    = state => state.manageEntitlements.entitlementGrantChangeLogReducer.events.cache;
export const entitlementGrantChangeLogDataSelector: CachedTableDataSelector<LogHits[]>
    = state => state.manageEntitlements.entitlementGrantChangeLogReducer.events;
export const entitlementGrantChangeLogResultSelector = getCachedTableResultSelector(
    entitlementGrantChangeLogCacheSelector,
    entitlementGrantChangeLogStateSelector,
);
